import React, { useLayoutEffect, useState } from 'react';
import ContentTabs from '../library/ContentTabs';
import { SELECTORS } from 'chameleon/packages/blue-book-player/constants/selectors';
import { getValidContentContainers } from 'chameleon/packages/blue-book-player/utils';

const MobileContentTabs = ({
  questionNr,
  questionEl,
  reference,
  isFrqQuestion,
}) => {
  const [elements, setElements] = useState({
    passageContainerElements: [],
    questionContainerElements: [],
  });
  useLayoutEffect(() => {
    let areContentElementsFound = false;
    SELECTORS.TWO_COLUMNS.some((selectors) => {
      const {
        isContainerValid,
        passageContainerElement,
        questionContainerElement,
      } = getValidContentContainers(questionEl, selectors);

      if (
        isContainerValid &&
        passageContainerElement &&
        questionContainerElement
      ) {
        areContentElementsFound = true;
        setElements({
          passageContainerElements: [passageContainerElement],
          questionContainerElements: [questionContainerElement],
        });

        return true;
      }

      return false;
    });

    if (!areContentElementsFound && isFrqQuestion) {
      setElements({
        passageContainerElements: [
          questionEl.querySelector(SELECTORS.QUESTION),
        ],
        questionContainerElements: [
          questionEl.querySelector(SELECTORS.QUESTION_ANSWER_WRAPPER),
          questionEl.querySelector(SELECTORS.CROSSOUT_CONTAINER),
        ],
      });
    }
  }, [reference, isFrqQuestion]);

  const { passageContainerElements, questionContainerElements } = elements;

  return (
    <ContentTabs
      questionNr={questionNr}
      passageContainerElements={passageContainerElements}
      questionContainerElements={questionContainerElements}
    />
  );
};

export default MobileContentTabs;
